module.exports = __webpack_public_path__ + "static/media/graph-bottom.ff56a0fc.png";